import { StepConnector } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const rootStyle = makeStyles(theme => ({
    stepperBackgroundColor:{
        width: "100%",
        background:`transparent`,
        marginBottom: '32px'
    },
    stepLabelLine : {
        borderBottom: `2px solid #01B5DE !important`,
        position: "absolute",
        left: 'calc(-50% + 16px)',
        right:' calc(-50% + 16px)',
        top: '16px',
        maxWidth: 'calc(100% - 32px)'
    },
}))

const useColorlibStepIconStyles = makeStyles(theme => ({
    root: {
        border: `1px solid ${theme.palette.primary.dashedBorderColor} !important`,
        zIndex: 1,
        color: '#01B5DE !important',
        width: "25pt",
        height: "25pt",
        display: "flex",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center"
    },
    active: {
        borderColor: "#01B5DE !important",
    },
    completed: {
        borderColor: "#01B5DE !important",
    },
    incomplete: {
        borderColor: "#BABEC3 !important",
    } 
}))

const QontoConnector = withStyles(theme => ({
    alternativeLabel: {
        top: 16,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    active: {
        '& $line': {
            borderColor: `#01B5DE !important`,
            borderWidth: true ? '1px' : '3px'
        },
    },
    completed: {
        '& $line': {
            borderColor: `#01B5DE !important`,
            borderWidth: true ? '1px' : '3px'
        },
    },
    line: {
        borderColor: `${theme.palette.primary.dashedBorderColor} !important`,
        borderTopWidth: 1,
        borderRadius: 1,
        width: "auto",
        marginLeft: "1px"
    },
}))(StepConnector);

export { rootStyle, useColorlibStepIconStyles, QontoConnector }
